import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { getButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import { useSelector } from 'react-redux';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { SALES } from 'self-service-api/constants/ProductLines';
import { ANNUAL } from 'self-service-api/constants/Terms';
import { SCREENS } from '../../constants/tracking/Screens';
import { SSM0010_RECOMMENDED_STARTER_FOOTER } from '../../constants/tracking/TrackingSources';
import { SuiteCTA } from '../../features/purchaseMotions/components/SuiteCTA';
import useSuitePurchaseMotions from '../../features/purchaseMotions/hooks/useSuitePurchaseMotions';
import { useSuiteRecommendationModelFeedback } from '../../hooks/useRecommendations';
import { useAppSelector } from '../../reducers';
import { hasPricingAndPurchasingSucceededSelector, hasPurchaseMotionsSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { currentSuiteSkuIdsForProductLevelSelector } from '../../selectors/ProductsSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import CrmSuitePriceTermOverride from '../merch-card/price-display/CrmSuitePriceTermOverride';
import { useShowPricePerMonthPerSeat } from '../merch-card/seats-display/useSeatsDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendedStarterFooter = () => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPurchaseMotionsSucceeded = useAppSelector(hasPurchaseMotionsSucceededSelector);
  const ctaVariantProps = getButtonVariantProps({
    variant: 'table-header'
  });
  const purchaseMotions = useSuitePurchaseMotions({
    productLevel: STARTER,
    returnFirstCTAOnly: true
  });
  const skuIds = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return [];
    return currentSuiteSkuIdsForProductLevelSelector(state, {
      productLevel: STARTER
    });
  });
  // only show price/mo/seat for bundled suite sku
  const skuId = skuIds && skuIds.length === 1 ? skuIds[0] : undefined;
  const showPricePerMonthPerSeat = useShowPricePerMonthPerSeat({
    skuId
  });
  const {
    onClick
  } = useSuiteRecommendationModelFeedback({
    productLevel: STARTER
  });
  return /*#__PURE__*/_jsx(View, {
    textAlign: "center",
    inlineSize: "100%",
    backgroundColor: "fill-brand-subtle",
    paddingBlock: "1300",
    children: /*#__PURE__*/_jsxs(View, {
      inlineSize: "100%",
      maxInlineSize: "900px",
      marginInline: "auto",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        typography: "body-400",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "upgradePages.footer.title"
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        marginBlock: "500",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.footer.subtitle"
        }), "\xA0", /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
            isLoading: !hasPricingAndPurchasingSucceeded,
            heights: [19],
            widths: [75],
            children: /*#__PURE__*/_jsx(CrmSuitePriceTermOverride, {
              productLevel: STARTER,
              termOverride: ANNUAL,
              showPricePerMonthPerSeat: showPricePerMonthPerSeat
            })
          })
        })]
      }), /*#__PURE__*/_jsx(View, {
        inlineSize: "200px",
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !hasPurchaseMotionsSucceeded,
          heights: [47],
          widths: [109],
          children: purchaseMotions.map(purchaseMotion => /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(SuiteCTA, Object.assign({
              purchaseMotion: purchaseMotion,
              productLevel: STARTER,
              trackingSource: SSM0010_RECOMMENDED_STARTER_FOOTER,
              screen: SCREENS[SALES],
              onClick: onClick,
              purchaseMotionLocation: 'MERCH_CARD'
            }, ctaVariantProps))
          }, purchaseMotion))
        })
      })]
    })
  });
};
export default RecommendedStarterFooter;